<div class="ald-tip" [pTooltip]="tip">
    <al2-icon iconClass="material-icons" icon="info_outline" (click)="showTip = !showTip"></al2-icon>
</div>
